import { addFavorite, delFavorite } from '../../service'
const collect_mixin = {
  inject: ['showCollectMessage','showCCollectMessage','login'],
  methods: {
    async cancelCollect(content_type, content_id, cb, cb_param, again) { // 取消收藏
      if (!this.$store.state.user_key) {
        this.login()
        return
      }
      
      let res = await delFavorite({
        user_key: this.$store.state.user_key,
        content_type: content_type,
        content_id: content_id,
        type: 1
      }, (error) => {this.$Message.error('取消收藏请求错误')})
      if (res.status == 'success') {
        if (this.$store.state.collect_c_message != 0 && !again) {
          this.showCCollectMessage()
        } else {
          this.$Message.warning('已取消收藏！')
        }
        if (cb) {
          cb(cb_param)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    async addCollect(content_type, content_id, cb, cb_param) { // 添加收藏(0快讯，1报告，2专题)
      if (!this.$store.state.user_key) {
        this.login()
        return
      }
      
      let res = await addFavorite({
        user_key: this.$store.state.user_key,
        content_type: content_type,
        content_id: content_id,
        type: 1
      }, (error) => {this.$Message.error('添加收藏请求错误')})
      if (res.status == 'success') {
        if (this.$store.state.collect_message != 1) {
          this.showCollectMessage()
        } else {
          this.$Message.success('收藏成功！')
        } 
        if (cb) {
          cb(cb_param)
        }
      } else {
        this.$Message.error(res.message)
      }
    }
  }
}
export { collect_mixin }
